import imgKibo from '../../assets/projects/kibo.png';
import imgAdsprintAI from '../../assets/projects/adsprintai.png';
import imgSBSBiophotonics from '../../assets/projects/bionova.png';
import { translations } from '../i18n/translations';

// Datos base sin traducciones (solo refs y config)
export const projectsDataBase = [
  {
    id: 1,
    key: 'kibo',
    image: imgKibo,
    technologies: ['Figma', 'Python', 'Flask', 'TensorFlow', 'GitHub', 'MongoDB', 'Docker'],
    link: 'https://web.kibo.aventiscali.com/',
    imagePosition: 'left',
  },
  {
    id: 2,
    key: 'sbsBiophotonics',
    image: imgSBSBiophotonics,
    technologies: ['Arduino', 'C++', 'Fusion 360', 'KiCad', 'GitHub'],
    link: 'https://biophotonics.bionovacali.com/',
    imagePosition: 'left',
  },
  {
    id: 3,
    key: 'adsprintAI',
    image: imgAdsprintAI,
    technologies: ['Figma', 'Python', 'Flask', 'n8n', 'GitHub', 'MongoDB', 'Supabase', 'Docker', 'AWS', 'OpenAI'],
    link: 'https://www.adsprintai.online/',
    imagePosition: 'left',
  },
];

/**
 * Obtiene los proyectos con textos traducidos
 * @param {string} language - 'es' o 'en'
 * @returns {Array} Array de proyectos con títulos y descripciones traducidos
 */
export const getProjectsWithTranslations = (language = 'es') => {
  return projectsDataBase.map(project => ({
    ...project,
    title: translations[language].projectsData[project.key].title,
    description: translations[language].projectsData[project.key].description,
  }));
};

/**
 * Selecciona N proyectos aleatorios únicos con traducciones
 * @param {number} count - Cantidad de proyectos a seleccionar
 * @param {string} language - 'es' o 'en'
 * @returns {Array} Array de proyectos seleccionados aleatoriamente con traducciones
 */
export const getRandomProjects = (count = 3, language = 'es') => {
  const projectsWithTranslations = getProjectsWithTranslations(language);
  const shuffled = [...projectsWithTranslations].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, projectsWithTranslations.length));
};
